/// <reference path="../types/index.d.ts" />

import '../client_forms/thecateredaffair2ica/style.css';
import FormStructure from './thecateredaffair2ica/form_structure';

export default FormStructure;